import { TokenResponse } from '@openid/appauth';
import { Injectable, Inject, Component  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Location } from '@angular/common';
import { Cookie } from './utils/cookies';
import { AuthService, AuthData, AuthConfigProvider, AuthStorage, AuthConfig } from '@tesla/ng-auth';
import { StorageSettings } from './utils/storage.settings';
import { AppSettings } from './app.settings';
// import { UserData } from './common/models/userData';

import { LocalstorageService } from 'src/app/services/localstorage.service';
import { Constants } from 'src/app/core/constants';
import { UserSuppliersData } from './models/auth/usersuppliersdata';
import { UserData } from './models/auth/userdata';
import { UserPermissions } from './permissions';
import { AppGlobalDataService } from 'src/app/services/appglobaldata.service';
import { AppGlobalDataProperties } from 'src/app/core/appglobaldata';
import { UISupplierContext } from 'src/app/models/internal/uisuppliercontext';
import { NGXLogger } from 'ngx-logger';
import UIHelper from './core/utility/ui-helper';

/**
 * Provides a custom behavior when having okta as a login provider service.
 */
@Injectable()
export class ExternalAuthService extends AuthService {

    private headers: HttpHeaders;
    private storage: any;

    private auth_nonce = 'authNonce';
    private auth_state = 'authStateControl';
    private auth_validate_error = 'authError';
    private auth_validate_errordesc = 'authErrorDescription';

    private access_token = 'access_token';
    private IdToken = 'IdToken';
    private user_email = 'ssEmail';
    private user_username = 'X-PortalIdentity-UserName';
    private user_currentSupplierCode = 'CurrentSupplierCode';
    private user_CorrelationId = 'CorrelationId';
    private user_displayname = 'ssDisplayname';
    // private user_supplierCode: string = 'CurrentSupplierCode';
    private user_typeid = 'ssUserTypeid';
    private user_CSRFToken = 'ssCSRFToken';
    private user_SupplierName = 'ssUserSupplierName';
    private user_SupplierSiteCode = 'ssUserSupplierSiteCode';
    private user_SubcontractSuppliersLookup = 'ssUserSubcontractSuppliersLookup';
    private user_IsSupplierEdiEnabled = 'IsSupplierEdiEnabled';
    private user_SuppliersData = 'SuppliersData';
    private user_isPlanner = 'IsPlanner';
    private user_isEmployee = 'IsEmployee';
    private user_isReadOnly = 'IsReadOnlyUser';
    private user_isAdmin = 'IsAdmin';
    private user_isSupplier = 'IsSupplier';
    private user_Permissions = 'Permissions';
    private Packaging2APIUrl: string = 'Packaging2APIUrl';
    public redirectUrl: string;
    locStorage = Constants.localStorageKeys;

     /**
     * Constructor
     * Sets the default headers and storage for subsequent requests.
     *
     * @param {Router} _router
     * @param {Http} _http
     * @param {HttpClient} _apiHttpClient
     * @param {AppSettings} _configuration
     * @param {StorageSettings} _sessionSettings
     */
    constructor(
        private appSettings: AppSettings,
        private _sessionSettings: StorageSettings,
        private localstorageService: LocalstorageService,
        private appGlobalDataService: AppGlobalDataService,
        protected authConfigProvider: AuthConfigProvider,
        protected authData: AuthData,
        protected authStorage: AuthStorage,
        protected router: Router,
        protected route: ActivatedRoute,
        protected http: HttpClient,
        protected apiHttpClient: HttpClient,
        protected logger: NGXLogger,
        protected location: Location,
        ) {
        super(authConfigProvider, authData, authStorage, router, route, http);
        this.headers = new HttpHeaders();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');
        this.storage = localStorage;
        // const baseConfig = this.authConfigProvider.getBaseConfig();
        // TMS-4977
        // store the current location to be redirected to after login only if it's not auth related i.e. auth/callback or auth/error
        this.redirectUrl = location.path();
        this.logger.debug('RedirectUrl:', this.redirectUrl);
        if (this.okToSetRedirectURL()) {
            localstorageService.store(this.locStorage.RedirectUrl, this.redirectUrl);
        }
        // baseConfig.on_success =  (rtr: Router, response: TokenResponse, config: AuthConfig, data: AuthData, storage: AuthStorage) =>
        // this.onSuccess(baseConfig, authData, rtr, storage, _sessionSettings, appSettings);
        UIHelper.updateLoggerConfig(appSettings, logger);
    }

  okToSetRedirectURL(): boolean {
    if (
        this.redirectUrl.includes('auth') ||
        this.redirectUrl.includes('home') ||
        this.redirectUrl.includes('packageleveltemplateList')) { // packageleveltemplateList is a common page so need to know the context
        return false;
    } else {
        return true;
    }
  }

 onSuccess(authConfig: AuthConfig, authData: AuthData, router: Router, authStorage: AuthStorage, _storage: StorageSettings, appSettings: AppSettings): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            const userInfo = authData.getUserInfo();
            const accesstokeninfo = authData.getAccessToken();
            let headers = new HttpHeaders();
            headers = headers.set('X-PortalIdentity-UserName', userInfo.email);

            const me = this;
            const locStorage = this.locStorage;

            // _storage._user_displayname = userInfo.display_name;
            // _storage.UserDisplayName = userInfo.display_name;
            // me.user_displayname =  userInfo.display_name;

            me.store(me.user_username, userInfo.email);
            me.store(me.user_displayname, userInfo.display_name);
            me.store(me.user_email, userInfo.email);
            me.store(me.access_token, accesstokeninfo.accessToken);
            me.store(me.IdToken, accesstokeninfo.idToken);
            me.store(me.user_displayname, userInfo.display_name);
            this.appGlobalDataService.RefreshUserDisplayName(
                this.retrieve(this.user_displayname)
            );

            const env = window['env'];
            const provider = AuthConfigProvider.getCurrentAuthProvider(env.openid.id);
             if (provider == 'auth') {
                appSettings.Packaging2APIUrl = appSettings.Packaging2APIUrlV2;
             }
            me.store(me.Packaging2APIUrl, appSettings.Packaging2APIUrl);

            this.apiHttpClient
                .get<UserData>(`${this.appSettings.Packaging2APIUrl}/user/me`, { headers })
                .subscribe((ret: any) => {
                    const bag = {};

                    if (ret.User) {
                        bag['warpUserId'] = ret.User.WarpUserId;
                        bag['supplierCode'] = ret.User.WarpSupplierCode;
                        bag['userTypeId'] = ret.User.UserTypeId;
                    }
                    bag['csrfToken'] = ret.formToken;
                    bag['userSupplierName'] = ret.supplierName;
                    bag['userSupplierId'] = ret.supplierId;
                    bag['apiVersion'] = ret.apiVersion;

                    bag['customHeaders'] = {};
                    bag['customHeaders']['X-RequestVerificationToken'] = ret.formToken;
                    bag['customHeaders']['X-PortalIdentity-UserName'] = userInfo.email;

                    authData.setUserAttributes(bag);


                    // const ret = response.body;
                    const data = ret.User;
                    const warpSupplierCode = data.WarpSupplierCode;
                    const warpUserTypeId = data.UserTypeId;
                    let supplierName = '';
                    let supplierSiteCode = '';
                    const IsSupplierEdiEnabled = '';
                    const supplierData = ret.supplierData;
                    const listOfSupplierCodes: string[] = [];
                    const IsPlanner = data.IsPlanner;
                    const IsEmployee = data.IsEmployee;
                    const IsAdmin = data.IsAdmin;
                    const IsSupplier = data.IsSupplier;
                    const CorrelationId = data.CorrelationId;
                    const UISupplierContexts: UISupplierContext[] = [];

                    me.store(me.user_currentSupplierCode, warpSupplierCode);
                    me.store(me.user_typeid, warpUserTypeId);
                    me.store(me.user_CSRFToken, ret.formToken);
                    me.store(me.user_isPlanner, IsPlanner);
                    me.store(me.user_CorrelationId, CorrelationId);

                    const permissions = {};
                    (data.Permissions || []).forEach((p: string) => {
                        if (!permissions[p]) {
                            permissions[p] = true;
                        }
                    });
                    me.store(me.user_Permissions, permissions);
                    // check if read only user
                    if (data.Permissions && data.Permissions.length === 1 && data.Permissions[0] === 'Packaging_SearchPart_Read') {
                        me.store(me.user_isReadOnly, Constants.ReadOnlyUserSecurityKey);
                    }
                    if (IsEmployee) {
                        me.store(me.user_isEmployee, Constants.IsEmployeeCheckCode);
                    } else {
                        me.store(me.user_isEmployee, '0');
                    }
                    if (IsAdmin) {
                        me.store(me.user_isAdmin, Constants.IsAdminCheckCode);
                    } else {
                        me.store(me.user_isAdmin, '0');
                    }

                    this.appGlobalDataService.RefreshIsEmployee(me.retrieve(me.user_isEmployee));
                    me.store(me.user_isSupplier, IsSupplier);
                    this.appGlobalDataService.RefreshIsSupplier(IsSupplier);

                    if (supplierData && supplierData.length > 1) {
                        me.store(me.user_SuppliersData, supplierData);
                        supplierData.forEach(element => {
                            listOfSupplierCodes.push(element.SupplierCode);
                        });
                    }
                    if (supplierData && supplierData.length > 0) {
                        supplierData.forEach(supData => {
                            const sup = new UISupplierContext();
                            sup.Name = supData.Name;
                            sup.SupplierCode = supData.SupplierCode;
                            sup.SupplierId = supData.SupplierId;
                            UISupplierContexts.push(sup);
                        });
                        // debugger;
                        this.appGlobalDataService.RefreshUISupplierContexts(
                            UISupplierContexts
                        );
                        this.localstorageService.store(locStorage.UISupplierContexts, UISupplierContexts);
                    }
                    _storage.reloadSettings();

                    this.logger.debug('fetching supplier name');
                    // Fetching supplier Name
                    if (
                        data.WarpSupplierCode !== undefined &&
                        data.WarpSupplierCode != null &&
                        data.WarpSupplierCode !== ''
                    ) {
                        // me.store(me.user_SuppliersData, x);
                        const tempData: UserSuppliersData = supplierData.filter(
                            x => x.SupplierCode === data.WarpSupplierCode
                        );
                        if (tempData != null && tempData[0] != null) {
                            supplierName = tempData[0].Name;
                            supplierSiteCode = tempData[0].SerializationCode;
                            me.store(me.user_SupplierName, tempData[0].Name);
                            me.store(
                                me.user_SupplierSiteCode,
                                tempData[0].SerializationCode
                            );
                            me.store(
                                me.user_IsSupplierEdiEnabled,
                                tempData[0].IsAsnEdiEnabled
                            );
                            me._sessionSettings.reloadSettings();
                        }
                    }

                    Cookie.set(ret.cookieName, ret.cookieToken, 365, '/', null, true);

                    // Mark the actions as success
                    resolve(true);

                    this.redirectUrl = this.localstorageService.retrieve(this.locStorage.RedirectUrl);
                    me.router.navigate([this.redirectUrl]);
                    this.localstorageService.store(this.locStorage.RedirectUrl, '');
                    // Redirect to requested page or default.
                    // this.redirectToHome(router,authStorage);

                    // me._router.navigate(['/']);

                }, (error) => {
                    resolve(false);

                    // Logout so that it can be retried again.
                    authData.clear();

                    /*
                    // Handle error process.
                    if (authConfig.on_error) {
                        authConfig.on_error(router, 'There was a problem fetching your profile. Please try again or contact Tesla Support.');
                    }
*/

                    return Promise.reject(error.message || error);
                });
        });
    }

       /**
     * Stores a key value pair into the underlying storage.
     *
     * @param {string} key - Key to store
     * @param {any} - Value to store
     */
    public store(key: string, value: any) {
        this.storage.setItem(key, JSON.stringify(value));
    }

     /**
     * Retrieves a key's value from the underlying storage.
     *
     * @param {string} key - Key under which the value is stored.
     * @return {any} - The object value.
     */
    public retrieve(key: string): any {
        const item = this.storage.getItem(key);

        if (item && item !== 'undefined;') {
            return JSON.parse(this.storage.getItem(key));
        }

        return;
    }

}